// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class StringNodeId implements flatbuffers.IUnpackableObject<StringNodeIdT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): StringNodeId {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsStringNodeId(bb: flatbuffers.ByteBuffer, obj?: StringNodeId): StringNodeId {
    return (obj || new StringNodeId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsStringNodeId(
    bb: flatbuffers.ByteBuffer,
    obj?: StringNodeId,
  ): StringNodeId {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new StringNodeId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  namespaceIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  identifier(): string;
  identifier(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  identifier(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startStringNodeId(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addNamespaceIndex(builder: flatbuffers.Builder, namespaceIndex: number) {
    builder.addFieldInt16(0, namespaceIndex, 0);
  }

  static addIdentifier(builder: flatbuffers.Builder, identifierOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, identifierOffset, 0);
  }

  static endStringNodeId(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // identifier
    return offset;
  }

  static createStringNodeId(
    builder: flatbuffers.Builder,
    namespaceIndex: number,
    identifierOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    StringNodeId.startStringNodeId(builder);
    StringNodeId.addNamespaceIndex(builder, namespaceIndex);
    StringNodeId.addIdentifier(builder, identifierOffset);
    return StringNodeId.endStringNodeId(builder);
  }

  unpack(): StringNodeIdT {
    return new StringNodeIdT(this.namespaceIndex(), this.identifier());
  }

  unpackTo(_o: StringNodeIdT): void {
    _o.namespaceIndex = this.namespaceIndex();
    _o.identifier = this.identifier();
  }

  unpackFields(...fields: string[]): StringNodeIdT {
    const t = new StringNodeIdT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("namespace_index")) {
      t.namespaceIndex = this.namespaceIndex();
    }
    if (fieldSet.has("identifier")) {
      t.identifier = this.identifier();
    }
    return t;
  }
}

export class StringNodeIdT implements flatbuffers.IGeneratedObject {
  constructor(
    public namespaceIndex: number = 0,
    public identifier: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.identifier === null || this.identifier === undefined) {
      throw new Error('Required field "identifier" is not set');
    }
    const identifier = this.identifier !== null ? builder.createString(this.identifier!) : 0;

    return StringNodeId.createStringNodeId(builder, this.namespaceIndex, identifier);
  }

  clone(): StringNodeIdT {
    const obj = new StringNodeIdT();
    obj.namespaceIndex = this.namespaceIndex;
    obj.identifier = this.identifier;
    return obj;
  }

  equals(other: StringNodeIdT): boolean {
    if (this.namespaceIndex !== other.namespaceIndex) return false;
    if (this.identifier !== other.identifier) return false;
    return true;
  }
}

export function verifyStringNodeId(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "identifier");
  } finally {
    verifier.popDepth();
  }
}
